// LLM generated - Model gpt-5.2-codex
import type { PropsWithChildren } from 'react';

import { PromotionsModalsContextProvider as BasePromotionsModalsContextProvider } from './PromotionsModalsContext';
import PromotionsModals from './PromotionsModals';

function PromotionsModalsContextProvider({ children }: PropsWithChildren) {
  return (
    <BasePromotionsModalsContextProvider>
      {children}
      <PromotionsModals />
    </BasePromotionsModalsContextProvider>
  );
}

export default PromotionsModalsContextProvider;
